export const PARALLELBIBLE = "PARALLELBIBLE";
export const COMMENTARY = "COMMENTARY";
export const DICTIONARY = "DICTIONARY";
export const INFOGRAPHICS = "INFOGRAPHICS";
export const AUDIO = "AUDIO";
export const VIDEO = "VIDEO";
export const BOOKMARK = "BOOKMARK";
export const HIGHLIGHT = "HIGHLIGHT";
export const NOTE = "NOTE";
export const SEARCH = "SEARCH";
export const READINGPLANS = "READINGPLANS";
